import { buildPublicPageUrl } from "./pageSeo";

/** Recommended Open Graph size — 1.91:1 for LinkedIn, Facebook, Slack, iMessage. */
export const DEFAULT_OG_IMAGE_WIDTH = 1024;
export const DEFAULT_OG_IMAGE_HEIGHT = 546;

export const DEFAULT_OG_IMAGE = {
  path: "/og/jobuwin-share.png",
  width: DEFAULT_OG_IMAGE_WIDTH,
  height: DEFAULT_OG_IMAGE_HEIGHT,
  alt: "Jobuwin — genuine jobs. real people.",
  type: "image/png",
};

/** Per-path share images for public marketing pages (exact path match). */
export const PAGE_SOCIAL_PREVIEWS = {
  "/": DEFAULT_OG_IMAGE,
  "/job-seekers": DEFAULT_OG_IMAGE,
  "/job-search": DEFAULT_OG_IMAGE,
  "/how-it-works/applying": DEFAULT_OG_IMAGE,
  "/hiring-managers": DEFAULT_OG_IMAGE,
  "/pricing": DEFAULT_OG_IMAGE,
  "/how-it-works/hiring": DEFAULT_OG_IMAGE,
  "/blog": {
    path: "/blog/hiring-is-broken-hero.png",
    width: 1024,
    height: 682,
    alt: "JOBUWIN blog — insights on genuine hiring",
    type: "image/png",
  },
};

function normalizePath(path = "/") {
  const raw = String(path || "/").trim().split("?")[0].split("#")[0];
  if (!raw || raw === "") return "/";
  return raw.startsWith("/") ? raw : `/${raw}`;
}

function isAbsoluteImageUrl(value) {
  return /^https?:\/\//i.test(String(value || "").trim());
}

function inferImageType(pathOrUrl) {
  const value = String(pathOrUrl || "").trim().toLowerCase();
  if (value.endsWith(".png")) return "image/png";
  if (value.endsWith(".webp")) return "image/webp";
  if (value.endsWith(".gif")) return "image/gif";
  return "image/jpeg";
}

/**
 * Resolve share image metadata for a page. Explicit props win over path presets.
 */
export function resolveSocialPreview({
  path,
  canonicalPath,
  title,
  imagePath,
  imageAlt,
  imageWidth,
  imageHeight,
  imageType,
} = {}) {
  const pathKey = normalizePath(canonicalPath || path || "/");
  const preset = PAGE_SOCIAL_PREVIEWS[pathKey] || DEFAULT_OG_IMAGE;

  const resolvedPath = String(imagePath || preset.path || DEFAULT_OG_IMAGE.path).trim();
  const resolvedUrl = isAbsoluteImageUrl(resolvedPath)
    ? resolvedPath
    : buildPublicPageUrl(resolvedPath);
  const resolvedAlt = String(imageAlt || preset.alt || title || DEFAULT_OG_IMAGE.alt).trim();
  const resolvedWidth = Number(imageWidth || preset.width || DEFAULT_OG_IMAGE.width);
  const resolvedHeight = Number(imageHeight || preset.height || DEFAULT_OG_IMAGE.height);
  const resolvedType = String(imageType || preset.type || inferImageType(resolvedPath)).trim();

  return {
    imagePath: resolvedPath,
    imageUrl: resolvedUrl,
    imageAlt: resolvedAlt,
    imageWidth: Number.isFinite(resolvedWidth) && resolvedWidth > 0 ? resolvedWidth : DEFAULT_OG_IMAGE.width,
    imageHeight: Number.isFinite(resolvedHeight) && resolvedHeight > 0 ? resolvedHeight : DEFAULT_OG_IMAGE.height,
    imageType: resolvedType || DEFAULT_OG_IMAGE.type,
  };
}
